module.exports = __webpack_public_path__ + "img/img5.7a7dcf34.png";